export default "__VITE_ASSET__BRBRz$tQ__"